import { useEffect, useState } from 'react';
import { enablePush, pushState, type PushState } from '../lib/push';
import { IconClose } from './Icons';

const DISMISS_KEY = 'evo:push-prompt-dismissed';

const dismissed = () => {
  try {
    return localStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
};

/** Invites the user to turn on notifications (they need an explicit tap, especially on iOS). */
export function PushPrompt() {
  const [state, setState] = useState<PushState | null>(null);
  const [hidden, setHidden] = useState(dismissed);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void pushState().then(setState);
  }, []);

  if (hidden || !state || !['disabled', 'needs-install', 'denied'].includes(state)) return null;

  const close = () => {
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* storage unavailable */
    }
    setHidden(true);
  };

  const enable = () => {
    setError(null);
    enablePush()
      .then((s) => {
        setState(s);
        if (s === 'denied') setError('Уведомления запрещены. Разрешите их в настройках iPhone: Настройки → Уведомления → Evo.');
      })
      .catch(() => setError('Не удалось включить уведомления'));
  };

  return (
    <div className="push-prompt" role="status">
      <div className="push-prompt-text">
        {state === 'needs-install' ? (
          <>Чтобы получать уведомления на iPhone, добавьте Evo на экран «Домой»: «Поделиться» → «На экран „Домой“».</>
        ) : state === 'denied' ? (
          <>{error ?? 'Уведомления запрещены. Разрешите их в настройках устройства для Evo.'}</>
        ) : (
          <>
            Включите уведомления, чтобы узнавать о сообщениях и звонках, когда приложение закрыто.
            {error && <div className="form-error small">{error}</div>}
          </>
        )}
      </div>
      {state === 'disabled' && (
        <button className="btn primary small-btn" onClick={enable}>
          Включить
        </button>
      )}
      <button className="icon-btn small" onClick={close} aria-label="Скрыть">
        <IconClose size={16} />
      </button>
    </div>
  );
}
